// Featured Products Carousel Functionality
document.addEventListener('DOMContentLoaded', function() {
    // Initialize all featured product carousels
    const carouselSections = document.querySelectorAll('.best-selling-section');
    
    carouselSections.forEach(function(section) {
        const sectionId = section.querySelector('[id^="carouselContainer"]')?.id.replace('carouselContainer', '');
        if (sectionId) {
            initializeCarousel(sectionId);
        }
    });
});

function getTotalCardWidth() {
    // Calculate responsive card width based on screen size
    let cardWidth, gap;
    if (window.innerWidth <= 480) {
        cardWidth = 220; // Mobile card width
        gap = 16; // Mobile gap
    } else if (window.innerWidth <= 768) {
        cardWidth = 260; // Tablet card width
        gap = 33; // Default gap
    } else if (window.innerWidth <= 1024) {
        cardWidth = 280; // Small desktop card width
        gap = 33; // Default gap
    } else if (window.innerWidth <= 1919) {
        cardWidth = 300; // Medium desktop card width
        gap = 33; // Default gap
    } else {
        cardWidth = 332; // Large desktop card width
        gap = 33; // Default gap
    }
    
    return cardWidth + gap;
}

function initializeCarousel(sectionId) {
    const container = document.getElementById('carouselContainer' + sectionId);
    const progressBar = document.getElementById('paginationProgress' + sectionId);
    
    if (container) {
        container.setAttribute('data-current-slide', '0');
        
        // Add throttled scroll event listener for touch/mouse scrolling
        let scrollTimeout;
        container.addEventListener('scroll', function() {
            // Clear previous timeout
            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
            }
            
            // Update pagination immediately for smoothness
            updatePaginationFromScroll(sectionId);
            
            // Update arrow states
            updateArrowStates(sectionId);
            
            // Set timeout to update slide position after scrolling stops
            scrollTimeout = setTimeout(function() {
                const scrollLeft = container.scrollLeft;
                const totalCardWidth = getTotalCardWidth();
                const currentSlide = Math.round(scrollLeft / totalCardWidth);
                container.setAttribute('data-current-slide', currentSlide);
            }, 150);
        });
    }
    
    // Add event listeners to arrow buttons
    const arrowButtons = document.querySelectorAll('[data-section-id="' + sectionId + '"]');
    
    arrowButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const direction = this.getAttribute('data-direction');
            scrollCarousel(sectionId, direction);
        });
    });
    
    // Update arrow button states based on scroll position
    updateArrowStates(sectionId);
    
    // Update pagination on window resize
    window.addEventListener('resize', function() {
        const currentSlide = parseInt(container.getAttribute('data-current-slide') || '0');
        updatePaginationForSection(sectionId, currentSlide);
    });
}

function updatePaginationForSection(sectionId, currentSlide) {
    const container = document.getElementById('carouselContainer' + sectionId);
    const progressBar = document.getElementById('paginationProgress' + sectionId);
    
    if (progressBar && container) {
        // Get the current progress bar width based on screen size
        let progressBarWidth = 40; // Default for desktop
        if (window.innerWidth <= 480) {
            progressBarWidth = 30; // Mobile
        } else if (window.innerWidth <= 768) {
            progressBarWidth = 35; // Tablet
        }
        
        const maxProgress = 100 - progressBarWidth; // Maximum left position
        
        const totalCardWidth = getTotalCardWidth();
        const totalProducts = container.querySelectorAll('.product-card').length;
        const visibleProducts = Math.floor(container.clientWidth / totalCardWidth);
        const maxSlides = Math.max(0, totalProducts - visibleProducts);
        const progress = maxSlides > 0 ? (currentSlide / maxSlides) * maxProgress : 0;
        progressBar.style.left = `${progress}%`;
    }
}

function scrollCarousel(sectionId, direction) {
    const container = document.getElementById('carouselContainer' + sectionId);
    const progressBar = document.getElementById('paginationProgress' + sectionId);
    
    if (!container) {
        return;
    }
    
    const totalCardWidth = getTotalCardWidth();
    const currentScrollLeft = container.scrollLeft;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    
    let newScrollPosition;
    
    if (direction === 'left') {
        // Scroll left by one card width, but don't go below 0
        newScrollPosition = Math.max(0, currentScrollLeft - totalCardWidth);
    } else if (direction === 'right') {
        // Scroll right by one card width, but don't go beyond max scroll
        newScrollPosition = Math.min(maxScrollLeft, currentScrollLeft + totalCardWidth);
    } else {
        return;
    }
    
    // Only scroll if we're not already at the boundary
    if (newScrollPosition === currentScrollLeft) {
        return;
    }

    // Use native scroll instead of transform for consistency
    container.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
    });
    
    // Update current slide based on new position
    const currentSlide = Math.round(newScrollPosition / totalCardWidth);
    container.setAttribute('data-current-slide', currentSlide);
    
    // Update pagination smoothly
    updatePaginationSmooth(sectionId, newScrollPosition);
}

function updatePaginationFromScroll(sectionId) {
    const container = document.getElementById('carouselContainer' + sectionId);
    const progressBar = document.getElementById('paginationProgress' + sectionId);
    
    if (!container || !progressBar) {
        return;
    }
    
    const totalCardWidth = getTotalCardWidth();
    const scrollLeft = container.scrollLeft;
    const currentSlide = Math.round(scrollLeft / totalCardWidth);
    
    // Update the data attribute to keep track of current slide
    container.setAttribute('data-current-slide', currentSlide);
    
    // Calculate smooth pagination progress based on actual scroll position
    updatePaginationSmooth(sectionId, scrollLeft);
}

function updatePaginationSmooth(sectionId, scrollLeft) {
    const container = document.getElementById('carouselContainer' + sectionId);
    const progressBar = document.getElementById('paginationProgress' + sectionId);
    
    if (!progressBar || !container) {
        return;
    }
    
    // Get the current progress bar width based on screen size
    let progressBarWidth = 40; // Default for desktop
    if (window.innerWidth <= 480) {
        progressBarWidth = 30; // Mobile
    } else if (window.innerWidth <= 768) {
        progressBarWidth = 35; // Tablet
    }
    
    const maxProgress = 100 - progressBarWidth; // Maximum left position
    
    // Use actual scrollable distance instead of calculated distance
    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    
    // Calculate smooth progress based on actual scroll position
    const progress = maxScrollLeft > 0 ? (scrollLeft / maxScrollLeft) * maxProgress : 0;
    progressBar.style.left = `${Math.min(progress, maxProgress)}%`;
}

function updateArrowStates(sectionId) {
    const container = document.getElementById('carouselContainer' + sectionId);
    const leftArrow = document.querySelector('[data-section-id="' + sectionId + '"][data-direction="left"]');
    const rightArrow = document.querySelector('[data-section-id="' + sectionId + '"][data-direction="right"]');
    
    if (!container || !leftArrow || !rightArrow) {
        return;
    }
    
    const scrollLeft = container.scrollLeft;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    
    // Update left arrow state
    if (scrollLeft <= 0) {
        leftArrow.style.opacity = '0.5';
        leftArrow.style.cursor = 'not-allowed';
        leftArrow.disabled = true;
    } else {
        leftArrow.style.opacity = '1';
        leftArrow.style.cursor = 'pointer';
        leftArrow.disabled = false;
    }
    
    // Update right arrow state
    if (scrollLeft >= maxScrollLeft - 1) { // -1 for floating point precision
        rightArrow.style.opacity = '0.5';
        rightArrow.style.cursor = 'not-allowed';
        rightArrow.disabled = true;
    } else {
        rightArrow.style.opacity = '1';
        rightArrow.style.cursor = 'pointer';
        rightArrow.disabled = false;
    }
}

// Reviews.io Integration
function initReviewsIOWidgets() {
    const ratingContainers = document.querySelectorAll('.product-rating[data-reviews-io-product-id]');
    
    if (ratingContainers.length === 0) return;

    // Check if Reviews.io script is already loaded
    if (window.ReviewsWidget) {
        ratingContainers.forEach(container => {
            createRatingWidget(container);
        });
    } else {
        // Load Reviews.io script
        const script = document.createElement('script');
        script.src = 'https://widget.reviews.io/rating-snippet/dist.js';
        script.onload = function() {
            ratingContainers.forEach(container => {
                createRatingWidget(container);
            });
        };
        document.head.appendChild(script);
    }
}

function createRatingWidget(container) {
    try {
        const productId = container.getAttribute('data-reviews-io-product-id');
        const store = container.getAttribute('data-reviews-io-store');
        
        // Check if we have valid data before creating widget
        if (!productId || !store) {
            container.style.display = 'none';
            return;
        }
        
        new ReviewsWidget({
            store: store,
            product: productId,
            widget: 'polaris',
            display_options: {
                show_rating: true,
                show_review_count: true,
                show_review_text: false,
                show_reviewer_name: false,
                show_reviewer_avatar: false,
                show_review_date: false
            },
            container: container
        });
    } catch (error) {
        console.log('Reviews.io widget error:', error);
        // Hide container if widget fails
        container.style.display = 'none';
    }
}

// Initialize Reviews.io widgets when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    initReviewsIOWidgets();
});
